import React, { Children } from 'react';
import { CheckIcon, BookOpenIcon, LayoutDashboardIcon, MessageCircleHeartIcon, LifeBuoyIcon, UsersIcon, XIcon, CalculatorIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function FamiliesPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-1583" data-mp="f6m4mozkr3q8">
      <TopBar data-id="element-1584" data-mp="f3qa7amxqx6j" />
      <Header data-id="element-1585" data-mp="k4xh77h97sc5" />

      {/* Hero Section */}
      <section className="w-full bg-white py-20 md:py-28 border-b border-gray-200" data-id="element-1586" data-mp="k5pc0g311m1d">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1587" data-mp="o69598khc5i8">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1588" data-mp="o4obvm9wisly">
            {/* Left: Copy */}
            <div className="flex-1 text-left" data-id="element-1589" data-mp="3skpgbefmrfsw">
              <div className="inline-block bg-[#631bb7] bg-opacity-10 text-[#631bb7] px-4 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-1590" data-mp="3sjxwf0veb6ig">
                For Families
              </div>
              <h1 className="mb-6 text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#111111] leading-tight" data-id="element-1591" data-mp="2enadytl8rbvt">
                Your Parents Just Clicked
                <br data-id="element-1592" data-mp="29rlcultkpmxe" />
                Another Sketchy Link
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 leading-relaxed mb-10 max-w-2xl" data-id="element-1593" data-mp="24wo6jmnohro7">
                Aura can't teach your mom why that email was fake. Life360 can't
                help your dad understand what two-factor authentication actually
                does.{' '}
                <strong className="text-[#111111]" data-id="element-1594" data-mp="1qx6bipjshi6e">
                  Caveo is the patient tech expert your family never had
                </strong>{' '}
                — no surveillance required.
              </p>
              <div className="flex flex-col sm:flex-row items-start gap-4 mb-4" data-id="element-1595" data-mp="1h2eg9sdoj7es">
                <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1596" data-mp="3gd5qwoe043uh">
                  See How It Works
                </Link>
              </div>
              <p className="text-gray-500" data-id="element-1597" data-mp="1egx6lfc27z4h">
                One subscription. Whole family. Zero surveillance.
              </p>
            </div>

            {/* Right: Photo */}
            <div className="flex-1 w-full lg:max-w-[500px]" data-id="element-1598" data-mp="14pixqgy7xmyo">
              <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-1599" data-mp="1sfww0p7eci1p">
                <img src="https://cdn.magicpatterns.com/uploads/ni76AqBzVEWfwitJfYbfKB/family-photo.png" alt="A grandmother and granddaughter hugging and laughing together" className="w-full h-full object-cover" data-id="element-1600" data-mp="1sgoeqzfwalak" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Problem/Agitation Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-1601" data-mp="71900e5gtldd">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1602" data-mp="c2pvfu56kfmk">
          <div className="max-w-3xl mx-auto" data-id="element-1603" data-mp="2q9fpmfce37uq">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-8 text-center" data-id="element-1604" data-mp="2q84m8gmuw245">
              You Shouldn't Be Your Family's Unpaid IT Department
            </h2>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-1605" data-mp="2zam64of1ginz">
              <p className="text-xl text-[#111111] font-medium" data-id="element-1606" data-mp="2v8ispu8t7402">
                Every Sunday, the call comes.
              </p>

              <div className="bg-white rounded-xl p-6 border-2 border-gray-200 space-y-3 italic text-gray-500" data-id="element-1607" data-mp="27i4ybx2r4t2b">
                <p data-id="element-1608" data-mp="22l4tfphn1wcs">"The computer says my password is wrong."</p>
                <p data-id="element-1609" data-mp="2gb002gt0g6nc">"Netflix isn't working."</p>
                <p data-id="element-1610" data-mp="2gct4rqk2cgsp">"I got an email from Amazon but I didn't order anything."</p>
                <p data-id="element-1611" data-mp="2bjgs8esns0gb">"What's this charge on my credit card?"</p>
              </div>

              <p className="font-semibold text-[#111111]" data-id="element-1612" data-mp="1nu5p4qnu5tz0">
                You've tried everything.
              </p>

              <p data-id="element-1613" data-mp="1jskgxim8y3v5">
                You bought your parents McAfee (<strong data-id="element-1614" data-mp="1wil402l0313y">$109/year</strong>)
                because that's what Best Buy recommended. You set up Life360 (
                <strong data-id="element-1615" data-mp="21h4rw8j5mmyy">$300/year</strong>) so you know Mom got home safe. You
                even paid for Aura's $32/month family plan (
                <strong data-id="element-1616" data-mp="26f6aytgkymaf">$384/year</strong>) with the VPN they'll never turn on
                and the password manager they'll never use.
              </p>

              <div className="bg-red-50 rounded-xl p-6 border-2 border-red-100" data-id="element-1617" data-mp="2g73kzwvur87k">
                <p className="text-[#111111] font-bold text-xl mb-2" data-id="element-1618" data-mp="2k85leh1i9qb4">
                  Three subscriptions. $793/year.
                </p>
                <p className="text-gray-600 mb-0" data-id="element-1619" data-mp="2p8a6kkdcz97o">
                  And your dad still asks why he needs "that extra password
                  thing" every single time.
                </p>
              </div>

              <p data-id="element-1620" data-mp="uuiwjjr4anbp">
                <strong className="text-[#111111]" data-id="element-1621" data-mp="uv29em1wuliv">
                  Here's what nobody tells you:
                </strong>{' '}
                Monitoring apps don't teach digital literacy. VPNs don't explain
                phishing. Antivirus software doesn't build confidence.
              </p>

              <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] border-opacity-30 my-8" data-id="element-1622" data-mp="ngrrhb5m5mrq">
                <p className="text-xl text-[#111111] font-semibold text-center mb-0" data-id="element-1623" data-mp="igvs5p7v2jii">
                  Your family doesn't need another app watching them.
                  <br data-id="element-1624" data-mp="1b6m7u2p55tgq" />
                  <span className="text-[#631bb7]" data-id="element-1625" data-mp="1b6vy7re3m2my">
                    They need someone who can finally explain this stuff in a
                    way that makes sense.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution/Benefit Section */}
      <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-1626" data-mp="3lzp1fptlwm6v">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1627" data-mp="3lxc9qky1qxgm">
          <div className="max-w-4xl mx-auto" data-id="element-1628" data-mp="3gzuajm9tzwlt">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4 text-center" data-id="element-1629" data-mp="2916okvofcw7u">
              Meet Your Family's Digital Fiduciary
            </h2>
            <p className="text-xl text-gray-600 text-center mb-6" data-id="element-1630" data-mp="2d28daikptpvk">
              Caveo is different because we're not selling you surveillance
              disguised as security.
            </p>
            <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-1631" data-mp="240shpgyk7sbe">
              We're the world's first{' '}
              <strong className="text-[#111111]" data-id="element-1632" data-mp="1pb324gppzlrl">Digital Fiduciary</strong> —
              which means we have a legal duty to put your family's interests
              first, not push products that pay us commissions.
            </p>

            <h3 className="text-2xl font-bold text-[#111111] mb-8 text-center" data-id="element-1633" data-mp="1lb2misqvx4iy">
              What that means for your family:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1634" data-mp="16f3fllfihafe">
              <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-1635" data-mp="1bcd1ws7lt5z0">
                <div className="w-12 h-12 bg-[#631bb7] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-1636" data-mp="rquqv3hmlbv3">
                  <BookOpenIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1637" data-mp="nrce4uzyk73c" />
                </div>
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1638" data-mp="11qu1d5xlvcal">
                  Education that actually sticks
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1639" data-mp="wt27i6dehg3r">
                  Not 50-page PDFs nobody reads. Not YouTube tutorials your
                  parents won't watch. Just 28 plain-English lessons that teach
                  one critical skill at a time, sequenced by what threatens your
                  family most.
                </p>
              </div>

              <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-1640" data-mp="1fhqpajgl75bb">
                <div className="w-12 h-12 bg-[#631bb7] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-1641" data-mp="1ufizcw3d71i4">
                  <MessageCircleHeartIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1642" data-mp="1ph7smu8d9744" />
                </div>
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1643" data-mp="a2spm556nsy9">
                  Honest recommendations
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1644" data-mp="k18es2kngs54">
                  We'll tell you that most people don't need a standalone VPN.
                  We'll explain why password reuse is more dangerous than any
                  virus. We'll help you cancel the three security subscriptions
                  you're overpaying for —{' '}
                  <strong data-id="element-1645" data-mp="3shtjv8a5v12y">saving your family $500-1,000/year.</strong>
                </p>
              </div>

              <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-1646" data-mp="195xqq43j9uc">
                <div className="w-12 h-12 bg-[#631bb7] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-1647" data-mp="628t93sfotd6">
                  <LayoutDashboardIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1648" data-mp="34r7bffw8vesf" />
                </div>
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1649" data-mp="39opmbbtto432">
                  One family hub
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1650" data-mp="1qt376i0nxm1o">
                  No more being "family IT support" across four time zones. Your
                  parents get the answers. You get visibility. Everyone
                  maintains dignity. Nobody loses their Friday nights.
                </p>
              </div>

              <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-1651" data-mp="17x3gdajf8ojo">
                <div className="w-12 h-12 bg-[#631bb7] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-1652" data-mp="1363jg5aay6h6">
                  <UsersIcon className="w-6 h-6 text-[#631bb7]" data-id="element-1653" data-mp="z3gohvic45fr" />
                </div>
                <h3 className="text-xl font-bold text-[#111111] mb-3" data-id="element-1654" data-mp="u5ovey5yed9z">
                  Role-based access
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1655" data-mp="p4r3htv564va">
                  Parents learn at their own pace. Adult children can see
                  progress without hovering. Everyone gets appropriate guidance
                  for their tech comfort level.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-1656" data-mp="1kptgmuesiie7">
              <div className="bg-[#631bb7] bg-opacity-5 rounded-xl p-6 border border-[#631bb7] border-opacity-20" data-id="element-1657" data-mp="1ygyk67la3utt">
                <p className="text-sm font-semibold text-[#631bb7] uppercase tracking-wide mb-2" data-id="element-1658" data-mp="1ugob2m26woaq">
                  For Adult Children
                </p>
                <p className="text-[#111111] font-medium" data-id="element-1659" data-mp="11rzb4qcvep0k">
                  <strong data-id="element-1660" data-mp="11tk5ofz6q7yf">Freedom.</strong> Stop answering the same tech
                  questions every Sunday. Stop worrying about the calls you'll
                  get when something goes wrong.
                </p>
              </div>
              <div className="bg-[#631bb7] bg-opacity-5 rounded-xl p-6 border border-[#631bb7] border-opacity-20" data-id="element-1661" data-mp="2r5chel4jmn4b">
                <p className="text-sm font-semibold text-[#631bb7] uppercase tracking-wide mb-2" data-id="element-1662" data-mp="2m69b6xctuaur">
                  For Parents
                </p>
                <p className="text-[#111111] font-medium" data-id="element-1663" data-mp="2ypohomadgo9a">
                  <strong data-id="element-1664" data-mp="2yr7zwifl99dp">Dignity.</strong> Learn without feeling judged. Get
                  clear answers without bothering your kids about "simple"
                  questions.
                </p>
              </div>
              <div className="bg-[#631bb7] bg-opacity-5 rounded-xl p-6 border border-[#631bb7] border-opacity-20" data-id="element-1665" data-mp="2pr2rq62km6yh">
                <p className="text-sm font-semibold text-[#631bb7] uppercase tracking-wide mb-2" data-id="element-1666" data-mp="3dgx5cpuprzjs">
                  For Everyone
                </p>
                <p className="text-[#111111] font-medium" data-id="element-1667" data-mp="33npxmyci47gj">
                  <strong data-id="element-1668" data-mp="38nkr99nnvb5a">Save $500-1,000/year.</strong> Consolidate
                  subscriptions. Build lasting capability, not temporary fixes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof/Trust Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24" data-id="element-1669" data-mp="50kcd9ti4rw3">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1670" data-mp="eu7vt0bt8zhb">
          <div className="max-w-4xl mx-auto" data-id="element-1671" data-mp="9v51oaxdcdo4">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center" data-id="element-1672" data-mp="9wg2q2zfj7bj">
              Built by Someone Living This Same Story
            </h2>

            <div className="bg-white bg-opacity-10 rounded-2xl p-8 mb-12" data-id="element-1673" data-mp="vqb7bh7c33m">
              <p className="text-lg text-white text-opacity-90 leading-relaxed mb-6" data-id="element-1674" data-mp="3s0ztegyyfd2o">
                Jason Phillips spent 15 years at companies like Asana, Drift,
                and Quantcast watching the digital literacy gap widen between
                generations.
              </p>
              <p className="text-lg text-white text-opacity-90 leading-relaxed mb-6" data-id="element-1675" data-mp="3dcdfmjoz6tdk">
                Then his father lost money to cyber fraud. Then his cousin was
                impersonated on Facebook.
              </p>
              <p className="text-lg text-white text-opacity-90 leading-relaxed mb-6" data-id="element-1676" data-mp="34b5k29dug6n6">
                He looked at Aura ($384/year), Life360 ($300/year), and McAfee+
                ($109/year) and realized they were all solving the wrong
                problem.
              </p>
              <p className="text-xl text-[#00f4f8] font-semibold mb-6" data-id="element-1677" data-mp="1sub86fnva2lh">
                The market was selling monitoring. Families needed education.
              </p>
              <p className="text-lg text-white text-opacity-90 leading-relaxed" data-id="element-1678" data-mp="1xsmhmpa92b36">
                So he built Caveo — the first digital security platform that
                puts teaching before tracking, designed specifically for the
                sandwich generation managing tech for aging parents.
              </p>
            </div>

            <h3 className="text-xl font-semibold text-white text-opacity-80 mb-6 text-center" data-id="element-1679" data-mp="1eua1gjkx80y3">
              From Families Like Yours:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1680" data-mp="hew30oli84fa">
              <div className="bg-white rounded-2xl p-6" data-id="element-1681" data-mp="md7cuzbsuexi">
                <p className="text-gray-600 leading-relaxed mb-4 italic" data-id="element-1682" data-mp="2p0xkhe0hod2h">
                  "I bought this for my parents. Within two weeks, Mom stopped
                  calling me about every password reset. That alone was worth
                  way more than $6."
                </p>
                <p className="font-bold text-[#111111]" data-id="element-1683" data-mp="2xv2hyga4omqz">— Sarah M., 42</p>
                <p className="text-sm text-gray-500" data-id="element-1684" data-mp="2t0ybrz8osiqy">
                  Managing care for aging parents
                </p>
              </div>
              <div className="bg-white rounded-2xl p-6" data-id="element-1685" data-mp="32skt8dbmbe25">
                <p className="text-gray-600 leading-relaxed mb-4 italic" data-id="element-1686" data-mp="32rszz95htsf1">
                  "Caveo told me I could cancel two subscriptions I didn't need.
                  When does a security company ever do that?"
                </p>
                <p className="font-bold text-[#111111]" data-id="element-1687" data-mp="1me2srtj2uo16">— David R.</p>
                <p className="text-sm text-gray-500" data-id="element-1688" data-mp="1mecf974wyd24">Gen X executive</p>
              </div>
              <div className="bg-white rounded-2xl p-6" data-id="element-1689" data-mp="1ieaer1awzpof">
                <p className="text-gray-600 leading-relaxed mb-4 italic" data-id="element-1690" data-mp="1880uz0e7i2gb">
                  "My dad is 71 and actually understands two-factor
                  authentication now. I didn't think that was possible."
                </p>
                <p className="font-bold text-[#111111]" data-id="element-1691" data-mp="yi7rkmo7wtn5">— Jennifer K.</p>
                <p className="text-sm text-gray-500" data-id="element-1692" data-mp="13h0ytxcwvoev">Daughter</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Breakdown */}
      <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-1693" data-mp="tjegf0weleq5">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1694" data-mp="fjv744ruvxc9">
          <div className="max-w-4xl mx-auto" data-id="element-1695" data-mp="flg0hr2fpa8j">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-1696" data-mp="kioldzeyvsdh">
              What Your Family Gets
            </h2>

            <div className="space-y-8" data-id="element-1697" data-mp="29z7fz77g2obw">
              <div className="flex items-start" data-id="element-1698" data-mp="2ewz9u6rngkiq">
                <div className="w-14 h-14 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0" data-id="element-1699" data-mp="2evo7mbdurktq">
                  <BookOpenIcon className="w-7 h-7 text-[#631bb7]" data-id="element-1700" data-mp="2cg7zicydk132" />
                </div>
                <div data-id="element-1701" data-mp="28itqalap1tb2">
                  <h3 className="text-xl font-bold text-[#111111] mb-2" data-id="element-1702" data-mp="23hmjopkaf05z">
                    The Education Platform
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1703" data-mp="1yjky9xze2orc">
                    28 modules organized by risk (not alphabet soup). Everyone
                    starts with what matters most — password hygiene, two-factor
                    auth, backup basics. Delivered in plain English your parents
                    can understand without a tech degree.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-1704" data-mp="2hh5d0c8fw6y8">
                <div className="w-14 h-14 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0" data-id="element-1705" data-mp="3exb69ftmpx69">
                  <LayoutDashboardIcon className="w-7 h-7 text-[#631bb7]" data-id="element-1706" data-mp="3a5b1na2m6g3c" />
                </div>
                <div data-id="element-1707" data-mp="3hiiu8hh8lkgo">
                  <h3 className="text-xl font-bold text-[#111111] mb-2" data-id="element-1708" data-mp="3hjbvj2xffhrf">
                    The Family Dashboard
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1709" data-mp="3rfoq030spzn8">
                    One place to see where everyone stands. Role-based access
                    means you can help without hovering. Parents maintain
                    dignity. Adult children get peace of mind.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-1710" data-mp="987kdtxdrj7v">
                <div className="w-14 h-14 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0" data-id="element-1711" data-mp="e0scmr0n1o9a">
                  <MessageCircleHeartIcon className="w-7 h-7 text-[#631bb7]" data-id="element-1712" data-mp="iyabfokxyn3k" />
                </div>
                <div data-id="element-1713" data-mp="nzzof9rq5aua">
                  <h3 className="text-xl font-bold text-[#111111] mb-2" data-id="element-1714" data-mp="o0j5ypdgpx7s">
                    The Honest Advisor
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1715" data-mp="1daym2rpbcehl">
                    Most people don't need a VPN. Most free antivirus works
                    fine. Most "monitoring" services are security theater. We'll
                    tell you what your family actually needs and help you cancel
                    what you don't — saving you hundreds per year.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-1716" data-mp="uls9znj0yl4r">
                <div className="w-14 h-14 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0" data-id="element-1717" data-mp="uie6ud2je7w9">
                  <LifeBuoyIcon className="w-7 h-7 text-[#631bb7]" data-id="element-1718" data-mp="14atp7bhqwyho" />
                </div>
                <div data-id="element-1719" data-mp="zjbpsrvdf5yt">
                  <h3 className="text-xl font-bold text-[#111111] mb-2" data-id="element-1720" data-mp="zisg1yfvjnvv">
                    The Crisis Toolkit
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1721" data-mp="bs69ycpfkdoi">
                    When something goes wrong (because eventually it will),
                    nobody has to Google "what to do if..." We have step-by-step
                    response plans for every common threat — from locked
                    accounts to suspicious charges.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-1722" data-mp="29g0auke1g6a8">
                <div className="w-14 h-14 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center mr-6 flex-shrink-0" data-id="element-1723" data-mp="2dkgfkibx17nv">
                  <UsersIcon className="w-7 h-7 text-[#631bb7]" data-id="element-1724" data-mp="316wpnqjnsl05" />
                </div>
                <div data-id="element-1725" data-mp="367kh2dbsv3uw">
                  <h3 className="text-xl font-bold text-[#111111] mb-2" data-id="element-1726" data-mp="365q5hpmf4o3h">
                    Multi-Generational Design
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-1727" data-mp="2x6mjodvv9ula">
                    Your teenagers learn different skills than your parents.
                    Your parents get different guidance than you do. Everyone
                    gets what they need at the level that makes sense.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-1728" data-mp="20yn1ivn3k8fb">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-1729" data-mp="1m374chr7zwep">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1730" data-mp="1r1qrumlgpg96">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-1731" data-mp="1r4cx2fkvrjo8">
              Stop Paying for Surveillance.
              <br data-id="element-1732" data-mp="1i1lm0gvx2px4" />
              Start Building Confidence.
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-1733" data-mp="1i3oldriylvei">
              Your family doesn't need another monitoring app. They need the
              patient tech expert they've always wanted.
            </p>

            <div className="bg-white rounded-2xl p-8 border-2 border-gray-200 mb-8" data-id="element-1734" data-mp="ucj0gxy5wcxc">
              <p className="text-lg text-gray-600 mb-6" data-id="element-1735" data-mp="yduurgrzdmbv">
                For less than one coffee per month, everyone gets:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left max-w-lg mx-auto mb-6" data-id="element-1736" data-mp="fqltfy27nhd0">
                {['28 risk-prioritized security lessons', 'One centralized family dashboard', 'Role-based access (support without hovering)', 'Honest guidance (even when it costs us a sale)', 'Crisis response plans', 'No affiliate bias. No upsells. No fear tactics.'].map((item, index) => <div key={index} className="flex items-start" data-id="element-1737" data-mp="tp3ajcxm1vly" data-mpi={index}>
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0 mt-0.5" data-id="element-1738" data-mp="17fovd76mkfmh" />
                    <span className="text-[#111111]" data-id="element-1739" data-mp="13ewmif1o0cqq">{item}</span>
                  </div>)}
              </div>
              <div className="text-center mb-6" data-id="element-1740" data-mp="1hffq99z3kwn3">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-1741" data-mp="1cg346rg1vtlk">
                  $5.99
                </span>
                <span className="text-gray-500 text-lg" data-id="element-1742" data-mp="a380ivfrv1b0">/month</span>
                <span className="text-gray-500 text-lg ml-2" data-id="element-1743" data-mp="e40ajqwgxa8c">
                  for your entire family
                </span>
                <p className="text-gray-500 text-sm mt-1" data-id="element-1744" data-mp="j2v1jg4la53j">
                  No contract. Cancel anytime.
                </p>
              </div>
              <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md w-full sm:w-auto" data-id="element-1745" data-mp="nv4r2v1sl35a">
                Start Your Family's Digital Education
              </Link>
            </div>

            {/* Math breakdown */}
            <div className="bg-[#1a0647] rounded-2xl p-6 mb-8" data-id="element-1746" data-mp="16rwffiw6y8g7">
              <div className="flex items-center justify-center mb-3" data-id="element-1747" data-mp="33lr3zwhtayu8">
                <CalculatorIcon className="w-5 h-5 text-[#00f4f8] mr-2" data-id="element-1748" data-mp="38jsq6qajbe9x" />
                <span className="font-bold text-white" data-id="element-1749" data-mp="38m57d18gxklx">Do the math:</span>
              </div>
              <div className="text-white text-opacity-80 space-y-1 mb-4" data-id="element-1750" data-mp="312mg67p2ml29">
                <p data-id="element-1751" data-mp="2w91h0cbqrl1h">
                  Aura ($384/year) + Life360 ($300/year) + McAfee+ ($109/year) ={' '}
                  <strong className="text-white" data-id="element-1752" data-mp="2rb9mdajppktl">$793/year</strong>
                </p>
              </div>
              <p className="text-[#00f4f8] font-bold text-xl" data-id="element-1753" data-mp="2mdgjaqdph6xj">
                Caveo: $72/year. Save $721. Get better education.
              </p>
            </div>

            <div className="bg-[#631bb7] bg-opacity-5 rounded-xl p-6 border border-[#631bb7] border-opacity-20 mb-6" data-id="element-1754" data-mp="3f01anqu6lj13">
              <p className="font-bold text-[#111111] mb-2" data-id="element-1755" data-mp="39zwp3mef1y40">The Caveo Promise</p>
              <p className="text-gray-600" data-id="element-1756" data-mp="360e5qv28tv3a">
                If we don't make your family feel more confident and capable in
                the first 30 days, we'll refund you immediately. No questions.
                No hassle.
              </p>
            </div>

            <p className="text-gray-500 text-sm" data-id="element-1757" data-mp="3ih5k8voxm8oq">
              Join 2,000+ families who stopped paying for surveillance and
              started building capability.
            </p>
          </div>
        </div>
      </section>

      <Footer data-id="element-1758" data-mp="38jr2msr9vduu" />
    </div>;
}